import React, { PureComponent } from 'react';
import { setWindowLocation } from '@eb/http';
import { logCheckpointOnPageChange } from '@eb/janus';

import Divider from 'eventbrite_design_system/divider/Divider';
import transform from '../transform';
import defaultSettings from './settings';
import experimentSettings from './experimentSettings';

import {
    CREATE_EVENT_REFERRER,
    ORG_MARKETING_CATEGORY,
    OVERVIEW_CTA_ACTION,
    OVERVIEW_CTA_CLICKED,
    OVERVIEW_PACKAGES_ACTION,
    OVERVIEW_VIEW_ACTION,
} from '../../constants/analytics';
import {
    CREATE_PATH,
    OVERVIEW_PAGE,
    SHOW_LOW_ATV_UI,
} from '../../constants/main';
import { handleLoadDriftChatbot, loadCrazyEgg } from '../utils';

import PageTitle from '../../components/PageTitle';
import HeroBanner from '../../components/HeroBanner';
import Heading from '../../components/Heading';
import OrbitFeature from '../../components/OrbitFeature';
import TestimonialsBanner from '../../components/Testimonials';
import PackageOverview from '../../components/PackageOverview';
import TwoColumnCTA from '../../components/TwoColumnCTA';
import ColumnFeatures from '../../components/ColumnFeatures';
import ThreeColumnFeatures from '../../components/ThreeColumnFeatures';
import './overviewPage.scss';

export default class OverviewPage extends PureComponent {
    componentDidMount() {
        const { isAuthenticated, trackEvent, tld } = this.props;

        handleLoadDriftChatbot(tld, isAuthenticated);

        trackEvent({
            action: OVERVIEW_VIEW_ACTION,
            category: ORG_MARKETING_CATEGORY,
        });

        loadCrazyEgg();
    }

    _handleHeroBannerCTAClick(trackNavigationGAEvent) {
        trackNavigationGAEvent({
            action: OVERVIEW_CTA_ACTION,
            category: ORG_MARKETING_CATEGORY,
        });

        setWindowLocation(CREATE_PATH);
    }

    // EXPERIMENT_MARKER=LOW_ATV_UI
    // determine path of button based on whether user is authenticated
    _handleTwoColumnCTAClick(referrer) {
        const {
            showLowAtvUi,
            isAuthenticated,
            redirectToCreate,
            redirectToSignIn,
            goToPricing,
            domain,
        } = this.props;

        logCheckpointOnPageChange(OVERVIEW_CTA_CLICKED, domain);
        if (showLowAtvUi) {
            if (isAuthenticated) {
                redirectToCreate();
            } else {
                redirectToSignIn(referrer);
            }
        } else {
            goToPricing(OVERVIEW_PACKAGES_ACTION);
        }
    }

    render() {
        const {
            locale,
            isAuthenticated,
            goToPricing,
            packageTitles,
            trackEvent,
            showLowAtvUi,
        } = this.props;
        const currentExperiment = showLowAtvUi && SHOW_LOW_ATV_UI;
        const {
            heroBanner,
            brandStatementBanner,
            getStartedHeading,
            featureListOne,
            takeControlHeading,
            featureListTwo,
            orbit,
            socialFeatures,
            testimonials,
            makeExperienceFeatures,
            onsiteFeatures,
            packagesList,
        } = transform({
            locale,
            isAuthenticated,
            defaultSettings,
            currentExperiment,
            experimentSettings,
            page: OVERVIEW_PAGE,
        });

        return (
            <div data-automation="alp-overview">
                <PageTitle title={packageTitles.overview} />
                <HeroBanner
                    {...heroBanner}
                    onClick={() => this._handleHeroBannerCTAClick(trackEvent)}
                />
                <Heading
                    {...brandStatementBanner}
                    removeVerticalPadding={true}
                    useSmallerMessaging={true}
                    headingColor="white"
                    bgColor="grey-900"
                />
                <TwoColumnCTA
                    {...getStartedHeading}
                    reverseHorizontal={true}
                    hasImageOverflow={true}
                    onClick={this._handleTwoColumnCTAClick.bind(
                        this,
                        CREATE_EVENT_REFERRER,
                    )}
                />
                <ColumnFeatures {...featureListOne} hasMaxWidth={true} />
                <TwoColumnCTA
                    {...takeControlHeading}
                    hasImageOverflow={true}
                    onClick={this._handleTwoColumnCTAClick.bind(
                        this,
                        CREATE_EVENT_REFERRER,
                    )}
                />
                <div className="features-background__gradient">
                    <ThreeColumnFeatures
                        {...featureListTwo}
                        bgColor={null}
                        isFullWidth={true}
                        hasMarketingContainer={true}
                    />
                </div>
                <div className="eds-l-pad-top-12">
                    <OrbitFeature {...orbit} />
                </div>
                <ColumnFeatures {...socialFeatures} />
                <Divider />
                <TestimonialsBanner {...testimonials} />
                <ThreeColumnFeatures
                    {...makeExperienceFeatures}
                    bgColor="vibrant-purple"
                    textColor="grey-300"
                    headingColor="white"
                    iconColor="vibrant-yellow"
                    addExtraPadding={true}
                    hasMarketingContainer={true}
                />
                <div
                    className={
                        onsiteFeatures.features.length > 1
                            ? 'onsite-popout--container'
                            : 'onsite-popout--container__narrow'
                    }
                >
                    <ColumnFeatures
                        {...onsiteFeatures}
                        useRoundImages={true}
                        bgColor="grey-200"
                        hasLessTopPadding={true}
                    />
                </div>
                <PackageOverview
                    {...packagesList}
                    onClick={goToPricing.bind(null, OVERVIEW_PACKAGES_ACTION)}
                    headerColor="grey-900"
                    bgColor="white"
                />
            </div>
        );
    }
}
